var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
		pa5: _vm.$vuetify.breakpoint.smAndDown,
		palr5: _vm.$vuetify.breakpoint.mdAndUp,
	}},[(!_vm.showResult)?_c('div',[_c(_vm.initComponent,{tag:"component",attrs:{"dataId":this.$route.params.idStory,"infosStory":_vm.infosStoryDisplay,"countStory":_vm.countStory},on:{"displayResults":function($event){return _vm.displayResults()}}})],1):_c('div',[_c('ResultsStory',{attrs:{"stories":_vm.stories,"idFormation":_vm.idFormation,"idExercice":_vm.idExercice}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }